import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import buyClickedHandler from '../Shop/buyClickedHandler';
import audio from '../../utils/audio';
import Utils from '../../utils';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import ShopInterface from '../../api/ShopInterface';
import Logger from '../../lib/analytics/logger';
import { purchaseActionTriggers } from '../../constants/userActions';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var LimitedTimeOffer = /*#__PURE__*/function (_Component) {
  _inherits(LimitedTimeOffer, _Component);

  var _super = _createSuper(LimitedTimeOffer);

  function LimitedTimeOffer() {
    var _this;

    _classCallCheck(this, LimitedTimeOffer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.isLTOAvailable = true;
    _this.checkBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var profiles;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ShopInterface.getBillingProfiles();

            case 2:
              profiles = _context.sent;

              if (profiles.billingProfiles !== undefined) {
                _this.props.setPurchaseProfile(profiles.billingProfiles);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.formatAmounts = function (limitedTimeOfferData) {
      limitedTimeOfferData.AMOUNT = format(limitedTimeOfferData.AMOUNT);
      limitedTimeOfferData.BONUS_LOYALTY_AMOUNT = format(limitedTimeOfferData.BONUS_LOYALTY_AMOUNT);
      return limitedTimeOfferData;
    };

    _this._purchaseHandler = function (sku, name) {
      audio.onClick();
      var limitedTimeOffer = _this.props.limitedTimeOffer;
      sku = _this._getSKUBasedOnPlatform(limitedTimeOffer);
      name = limitedTimeOffer.NAME;
      Logger.setActionTrigger(purchaseActionTriggers.LIMITED_TIME_OFFER_BUY_BUTTON);

      _this.props.isLTOPurchase(true);

      _this.buyServerHandler = buyClickedHandler.bind(_assertThisInitialized(_this));

      _this.buyServerHandler(sku, name, '');
    };

    return _this;
  }

  _createClass(LimitedTimeOffer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkBillingProfile();
      this.buyServerHandler = buyClickedHandler.bind(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var limitedTimeOffer = this.props.limitedTimeOffer;

      if ((!limitedTimeOffer || Object.keys(limitedTimeOffer).length === 0) && this.isLTOAvailable) {
        this.isLTOAvailable = false;
        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
        QueryParamsProxy.modalPromiseAccept();
      }
    }
  }, {
    key: "_getSKUBasedOnPlatform",
    value: function _getSKUBasedOnPlatform(limitedTimeOffer) {
      if (Utils.getPlatform() === 'ios') {
        return limitedTimeOffer.MOBILE_PRODUCT_IAP_ID_IOS;
      }

      if (Utils.getPlatform() === 'android') {
        return limitedTimeOffer.MOBILE_PRODUCT_IAP_ID_ANDROID;
      }

      return limitedTimeOffer.CURRENCY_ITEM_ID;
    }
  }, {
    key: "render",
    value: function render() {
      var limitedTimeOffer = this.props.limitedTimeOffer;
      var limitedTimeOfferData;

      if (!Utils.isEmpty(limitedTimeOffer)) {
        limitedTimeOfferData = this.formatAmounts(limitedTimeOffer);
      }

      return this.props.render({
        limitedTimeOfferData: limitedTimeOfferData,
        purchaseHandler: this._purchaseHandler
      });
    }
  }]);

  return LimitedTimeOffer;
}(Component);

export { LimitedTimeOffer as default };